import { c as _c } from "react/compiler-runtime";
import { Box, Text } from "@chakra-ui/react";
interface PillProps {
  exists: boolean | undefined;
  trueData: string;
  falseData: string;
  noData: string;
  variant?: "pill" | "text";
}
const Pill: React.FC<PillProps> = t0 => {
  const $ = _c(13);
  const {
    exists,
    trueData,
    falseData,
    noData,
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "pill" : t1;
  let t2;
  if ($[0] !== exists) {
    t2 = () => {
      switch (exists) {
        case true:
          {
            return "red";
          }
        case false:
          {
            return "green";
          }
        default:
          {
            return "lightGrey";
          }
      }
    };
    $[0] = exists;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const getColor = t2;
  const color = getColor();
  let t3;
  if ($[2] !== exists || $[3] !== falseData || $[4] !== noData || $[5] !== trueData) {
    const getLabel = () => {
      switch (exists) {
        case true:
          {
            return trueData;
          }
        case false:
          {
            return falseData;
          }
        default:
          {
            return noData;
          }
      }
    };
    t3 = getLabel();
    $[2] = exists;
    $[3] = falseData;
    $[4] = noData;
    $[5] = trueData;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const label = t3;
  if (variant === "text") {
    let t4;
    if ($[7] !== color || $[8] !== label) {
      t4 = <Text as="span" display="inline-block" color={color}>{label}</Text>;
      $[7] = color;
      $[8] = label;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    return t4;
  }
  let t4;
  if ($[10] !== color || $[11] !== label) {
    t4 = <Box><Text bgColor={color} color="white" py="0.5" px="3" borderRadius="full" whiteSpace="nowrap">{label}</Text></Box>;
    $[10] = color;
    $[11] = label;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
};
export default Pill;